import React from "react";
import { inject, observer } from "mobx-react";
import ListSearch from "../bucket/ListSearch";
import { Label } from "react-bootstrap";
import { Link } from "react-router-dom";
import { StoreContext } from "../../contexts/StoreContext";
import MaintenanceAgencyLabel from "./MaintenanceAgencyLabel";

@inject("detailViewStore", "popupStore")
@observer
export class MatchingCubes extends React.Component {
  componentDidMount() {
    this.context.setSearchMatrix(this.props.searchMatrixKey, "");
  }

  helper_findCubeLinks(item) {
    let cubeLinks = [];
    if (item.items)
      for (let i = 0; i < item.items.length; i += 1) {
        if (item.items[i].object.type === "CubeLink")
          cubeLinks.push(item.items[i].object);
      }

    return cubeLinks;
  }
  static contextType = StoreContext;
  render() {
    const { navigationLookupResult, searchMatrixKey } = this.props;

    // render this view only for Cubes, ignore for others
    if (navigationLookupResult.params.type !== "Cube") {
      return null;
    }

    let matchingCubes = null;

    if (
      navigationLookupResult &&
      navigationLookupResult.navigationLookupRootItem
    ) {
      const items = navigationLookupResult.navigationLookupRootItem;
      matchingCubes = this.helper_findCubeLinks(items);
    }

    if (!matchingCubes) {
      return null;
    }

    const cubesGroupedByLinkId = this.context.groupCubesByValidity(
      matchingCubes,
      "cubeLinkId"
    );
    const filteredCubes = Object.values(cubesGroupedByLinkId).flat();

    const searchExpr = this.context.getSearchMatrix[searchMatrixKey] || "";

    const filteredMatchingCubes = filteredCubes.filter((item) => {
      if (searchExpr) {
        const namesInNestedObjects = item.name ? item.name.toLowerCase() : "";
        const codesInNestedObjects = item.code ? item.code.toLowerCase() : "";
        return (
          namesInNestedObjects.includes(searchExpr.toLowerCase()) ||
          codesInNestedObjects.includes(searchExpr.toLowerCase())
        );
      } else {
        return true;
      }
    });

    return (
      <div ref={this.props.innerRef} className="related-objects custom-panel">
        <div className="custom-panel-heading">
          <h4>Linked Cubes</h4>
        </div>
        <div className="custom-panel-body related-types-list">
          <ListSearch
            searchMatrixKey={searchMatrixKey}
            placeholder={"Filter by Name or Code"}
          />
          <div className="custom-panel-body">
            <div className="item-list-container">
              {filteredMatchingCubes.length
                ? filteredMatchingCubes.map((item, index) => (
                    <div className="related-object" key={index}>
                      <Link
                        className="object-name"
                        to={`/view/${item.type}/${item.tid}`}
                        target={"_blank"}
                      >
                        {`${item.name || "[No name]"} (${item.code})`}
                      </Link>
                      <Label className="object-type" bsStyle="success">
                        {item.type}
                      </Label>
                      {item.maintenanceAgencyId ? (
                        <MaintenanceAgencyLabel
                          maintenanceAgencyId={item.maintenanceAgencyId}
                        ></MaintenanceAgencyLabel>
                      ) : (
                        ""
                      )}
                    </div>
                  ))
                : "Nothing found"}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
